import { render, staticRenderFns } from "./OrderCodeDetails.vue?vue&type=template&id=5f793e13&"
import script from "./OrderCodeDetails.vue?vue&type=script&lang=js&"
export * from "./OrderCodeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports